import { Avatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar';

import { styled } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';

export const AvatarRoot = styled(Avatar)<{ $isSmall: boolean }>`
  align-items: center;
  background-color: ${Colors.gray[100]};
  border-radius: 100%;
  display: inline-flex;
  height: ${({ $isSmall }) => ($isSmall ? '2.5rem' : '3rem')};
  justify-content: center;
  overflow: hidden;
  user-select: none;
  vertical-align: middle;
  width: ${({ $isSmall }) => ($isSmall ? '2.5rem' : '3rem')};
`;

export const Image = styled(AvatarImage)`
  border-radius: inherit;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const Fallback = styled(AvatarFallback)`
  align-items: center;
  background-color: ${Colors.gray[100]};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;
